<template>
    <div>
        <el-dialog :title="'MchId和密钥'" :visible.sync="dialogVisible" width="30%" :before-close="handleClose"
            destroy-on-close :close-on-click-modal="false" :cancel-button-text="appKey ? '重置' : '获取MchId和密钥'">
            <div>
                <p>
                    MchId：
                    <span style="color: teal">{{ appKey }}</span>
                </p>
                <p>
                    AppSecret：
                    <span style="color: teal">{{ appSecret }} </span>
                    <el-button @click="copyToClipboard(`${appKey}\n${appSecret}`)">一键复制</el-button>
                </p>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleClose">关闭</el-button>
                <el-button :type="appKey != null ? 'danger' : 'primary'" @click="confirmReset">{{ appKey != null ? '重置'
            : '获取MchId和密钥' }}</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
    data() {
        return {
            dialogVisible: false,
            appKey: '',
            appSecret: '',
            confirmLoading: false,
            cancelButtonText: '',
            id: null
        };
    },
    methods: {
        init(id) {
            this.dialogVisible = true
            this.id = id;
            this.$http({
                url: "/api/CustomerCompany/GetAppKey?id=" + id,
                method: "get",
            }).then((res) => {
                this.appKey = res.data.response.AppKey;
                this.appSecret = res.data.response.AppSecret;
            });
        },
        copyToClipboard(text) {
    // Check for Clipboard API support
    if (navigator.clipboard) {
        navigator.clipboard.writeText(text).then(
            () => {
                this.$message.success("复制成功!");
            },
            () => {
                this.$message.error("复制失败！");
            }
        );
    } else {
        // Create a textarea element for multiline support
        let oTextarea = document.createElement("textarea");
        // Set its value to the text you want to copy
        oTextarea.value = text;
        // Make the textarea out of viewport
        oTextarea.style.position = "fixed";
        oTextarea.style.left = "-9999px";
        document.body.appendChild(oTextarea);
        oTextarea.select();
        try {
            // Execute the copy command
            var successful = document.execCommand("copy");
            var msg = successful ? "复制成功" : "复制失败";
            this.$message.success(msg);
        } catch (err) {
            console.error("复制失败", err);
            this.$message.error("复制失败");
        }
        // Remove the textarea after copy
        document.body.removeChild(oTextarea);
    }
},

        handleClose() {
            this.dialogVisible = false;
        },
        confirmReset() {
            if (this.appKey == null) {
                this.ResetAppkey(this.id);
            } else {
                this.$confirm('是否重置当前选中数据的秘钥?', '提示', {
                    confirmButtonText: '确认',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.ResetAppkey(this.id);
                }).catch(() => {
                    // Do nothing if canceled
                });
            }
        },
        ResetAppkey(id) {
            this.$http({
                url: "/api/CustomerCompany/PostAppKey?id=" + id,
                method: "post",
            }).then((res) => {
                this.init(id);
            });
        },
    }
};
</script>

<style></style>